import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const DaycareRegisterModal = createContext<ContextType | null>(null);

const DaycareRegisterModalProvider: ComponentWithChildren = ({ children }) => {
  const providerValue = useProviderValue();

  return (
    <DaycareRegisterModal.Provider value={providerValue}>
      {children}
    </DaycareRegisterModal.Provider>
  );
};

export const useDaycareRegisterModalContext = () => {
  const context = useContext(DaycareRegisterModal);
  if (context === undefined) {
    throw new Error(
      'the useDaycareRegisterModal should be used within EnrollDonorModalProvider!'
    );
  }

  return context;
};

export default DaycareRegisterModalProvider;
